import _isFunction from 'lodash/isFunction';
import _includes from 'lodash/includes';
import _isArray from 'lodash/isArray';
import _isEmpty from 'lodash/isEmpty';
import moment from 'moment';

import { diff } from 'lib/utils/date';

const getCheckIsTargetActivityTypeRef = (targetActivityTypeRefs = []) => {
  return (activityTypeRef) => {
    if (!_isArray(targetActivityTypeRefs) || _isEmpty(targetActivityTypeRefs)) {
      return false;
    }
    return _includes(targetActivityTypeRefs, activityTypeRef);
  };
};

const getAggClosedActivitiesMs = ({ activities = [], filterCb }) => {
  return activities.reduce((aggMs, activity) => {
    const { start, end } = activity;
    if (_isFunction(filterCb)) {
      const shouldIncludeActivityInAgg = filterCb(activity);
      if (!shouldIncludeActivityInAgg) {
        return aggMs;
      }
    }
    if (!end) {
      // only include closed activities
      return aggMs;
    }
    return aggMs + diff(end, start, 'milliseconds');
  }, 0);
};

/**
 * Creates the common activity set input structure used by both
 * CREATE_ACTIVITY_SET_WITH_WORK_ORDER and START_ACTIVITY_WITH_LABOR_TICKET
 */
const createActivitySetInput = ({
  machine,
  workOrderOp,
  partOperation,
  activityTypeRef,
  startAt,
}) => {
  const nowISO = moment().toISOString();
  const workOrderId = workOrderOp?.workOrderId;
  const workOrderOperationRef = workOrderOp?.workOrderOperationRef;

  return {
    machineRef: machine?.machineRef,
    activities: [
      {
        activityTypeRef,
        startAt: startAt || nowISO,
      },
    ],
    partNumber: partOperation?.partNumber,
    sequenceNumber: partOperation?.sequenceNumber,
    partOperationRef: partOperation.partOperationRef,
    cycleTime: workOrderOp?.cycleTimeMs || partOperation.cycleTimeMs,
    workOrderOperationRef,
    workOrderId,
    expectedUnitDuration: workOrderOp?.cycleTimeMs || partOperation.cycleTimeMs,
    idealUnitDuration: workOrderOp?.cycleTimeMs || partOperation.cycleTimeMs,
    expectedSetupDuration:
      workOrderOp?.setupTimeMs || partOperation.setupTimeMs,
    // TODO : Fractional quantities
    partCountMultiplier:
      workOrderOp?.quantityPerPart ||
      workOrderOp?.quantityPerCycle || // Scheduled runs are shimmed to quantityPerCycle
      partOperation.quantityPerPart ||
      1,
    actualParts:
      workOrderOp?.quantityPerPart ||
      workOrderOp?.quantityPerCycle || // Scheduled runs are shimmed to quantityPerCycle
      partOperation.quantityPerPart ||
      1,
  };
};

export {
  getAggClosedActivitiesMs,
  getCheckIsTargetActivityTypeRef,
  createActivitySetInput,
};
